import React, { useState, useEffect } from 'react';
import { firestore } from '../firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';
import './WorldDbFilter.css';

const NewWorldDbStatusFilter = ({ userId, onFilterChange, isLoading, currentStatusFilter }) => {
  const [statusOptions, setStatusOptions] = useState([
    { value: 'all', label: 'All' },
    { value: 'ready_to_spy', label: 'Ready To Spy' },
    { value: 'Not Contacted', label: 'Not Contacted' },
    { value: 'Introduced', label: 'Introduced' },
    { value: 'First Follow-up', label: '1. Follow-Up' },
    { value: 'Second Follow-up', label: '2. Follow-Up' },
    { value: 'Third Follow-up', label: '3. Follow-Up' },
    { value: 'Interested', label: 'Interested' },
    { value: 'Not Interested', label: 'Not Interested' }
  ]);

  // In Zukunft können die Status dynamisch geladen werden
  /*
  useEffect(() => {
    if (!userId) return;

    const fetchStatusOptions = async () => {
      // Annahme: Es gibt eine Collection 'statuses' unter dem User
      const statusRef = collection(firestore, `World/${userId}/statuses`);
      try {
        const snapshot = await getDocs(statusRef);
        const fetchedOptions = snapshot.docs.map(doc => ({
          value: doc.id,
          label: doc.data().label
        }));
        // Füge 'All' und 'Not Contacted' als Standard hinzu
        setStatusOptions([
          { value: 'all', label: 'All' },
          { value: 'Not Contacted', label: 'Not Contacted' },
          ...fetchedOptions
        ]);
      } catch (error) {
        console.error("Could not fetch status options:", error);
      }
    };

    fetchStatusOptions();
  }, [userId]);
  */

  const handleStatusChange = (e) => {
    onFilterChange(e.target.value);
  };

  return (
    <div className="world-db-filter">
      <div className="world-db-filter-content">
        <label htmlFor="statusFilter" className="world-db-filter-label">
          Status:
        </label>
        <select
          id="statusFilter"
          className="world-db-filter-select"
          value={currentStatusFilter || 'all'}
          onChange={handleStatusChange}
          disabled={isLoading}
          title="Filter by lead status"
        >
          {statusOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default NewWorldDbStatusFilter; 